import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
// View Components
import Menu from './views/Menu.vue'
import Announcement from './views/Announcement.vue'
import Preferences from './views/Preferences.vue'
import QueryTapirMk from './views/QueryTapirMk.vue'
import QueryTapirMd from './views/QueryTapirMd.vue'
import Login from './views/Login.vue'
import NotFound from './views/NotFound.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'menu',
      component: Menu,
      meta: { page: { title: 'メニュー' } },
    },
    {
      path: '/announcement',
      name: 'announcement',
      component: Announcement,
      meta: { page: { title: 'お知らせ' } },
    },
    {
      path: '/preferences',
      name: 'preferences',
      component: Preferences,
      meta: { page: { title: '個人設定', hasHelp: false } },
    },
    {
      path: '/query-tapir-mk/:queryId?',
      name: 'query-tapir-mk',
      component: QueryTapirMk,
      meta: {
        page: {
          hasHelp: true,
          helpUrl: `${
            process.env.VUE_APP_HELP_SITE_URL_BASE
          }/tmp_tapir-mk.html`,
        },
      },
    },
    {
      path: '/query-tapir-md/:queryId?',
      name: 'query-tapir-md',
      component: QueryTapirMd,
      meta: {
        page: {
          hasHelp: true,
          helpUrl: `${
            process.env.VUE_APP_HELP_SITE_URL_BASE
          }/tmp_tapir-md.html`,
        },
      },
    },
    {
      path: '/about',
      name: 'about',
      meta: { page: { title: 'About' } },
      // ルート単位でのコード分割
      // ビルドしたときにメインのスクリプトとは別に `about.[hash].js` がこのルート用に作成されます。
      // このルートを表示するときになって初めてロードされるので、使用頻度が低いルートの場合は
      // こうしておくとパフォーマンス、ビルドしたjsのファイルサイズ削減に役立ちます。
      component: () =>
        import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { page: { title: 'Login' } },
      props: true,
    },
    {
      // SPAをサーバーにデプロイするとき、どのパスでもとりあえずindex.htmlを返すように設定します。
      // ※ 例えば、/help/ponでリロードするとサーバーには/help/ponのURLでリクエストする。
      //    そういうときもサーバーでちゃんとindex.htmlを返さないと404になってしまう。
      // このRouterでパスが見つからない場合<router-view>に何も表示されないことになってしまう
      // ので、どのルートにもマッチしなかった場合は404用のコンポーネントを描画します。
      path: '*',
      component: NotFound,
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  const account = store.state.account

  if (to.name !== 'login' && !account.userId) {
    return next({ path: '/login' })
  }

  if (to.name === 'login' && account.userId) {
    return next({ path: '/' })
  }

  setDocumentTitle(to, store.state.menus)

  next()
})

/**
 * meta.page.titleに設定されている文字列をdocument.titleとします。
 * ただし、分析画面のルートはnameだけ定義していて、to.meta.page.titleは定義していません。
 * その場合はメニュー一覧からtoのメニューを探してその日本語名を設定します。
 *
 * 何れもマッチしない場合、document.titleには何も設定されません。
 *
 * @param {Object} to
 * @param {Array} queryMenus
 */
function setDocumentTitle(to, queryMenus) {
  if (to.meta && to.meta.page && to.meta.page.title) {
    document.title = `${to.meta.page.title}`
    return
  }

  if (to.name && to.name.startsWith('query-')) {
    if (queryMenus.length === 0) {
      throw new Error(
        'メニューがFetchされていない状態で分析画面がリクエストされました。',
      )
    }

    const menuCode = to.name.substr('query-'.length)
    const menu = queryMenus.find(m => m.menuCode === menuCode)

    if (menu) {
      document.title = menu.menuLongName
    }
  }
}

export default router
